module.exports = __webpack_public_path__ + "static/media/Playstore button.1a0d7f19.png";